module.exports = __webpack_public_path__ + "static/media/d_logo.d0def4d6.png";